import {
  containerItemDialog,
  copyDialog,
  flexContainerDialog,
  getalbeeldDialog,
  heuristiekDialog,
  hornerDialog,
  klokDialog,
  mabDialog,
  pijlenschemaDialog,
  positietabelDialog,
  rehydrate,
  rekenreeksDialog,
  rekentabelDialog,
  roosterDialog,
  splitsboomDialog,
  tipDialog,
  tussenstapDialog,
  visueleVolgordeDialog,
} from '@campus/external-custom-buttons';
import FroalaEditor from 'froala-editor';

type InsertHtml = (html: string) => void;
type DialogFn = (insert: InsertHtml) => void;

interface ButtonSpec {
  name: string;
  title: string;
  icon: string;
  dialog: (iconPath: string) => DialogFn;
  needsRehydrate?: boolean;
}

const BUTTONS: readonly ButtonSpec[] = [
  { name: 'hidecopy', title: 'Hide Copy', icon: 'hide-copy.png', dialog: () => (i) => copyDialog(i) },
  { name: 'flexwrap', title: 'container', icon: 'container.png', dialog: () => (i) => flexContainerDialog(i) },
  { name: 'containeritem', title: 'container item', icon: 'item.png', dialog: () => (i) => containerItemDialog(i) },
  { name: 'splits', title: 'splits', icon: 'split.png', dialog: () => (i) => splitsboomDialog(i) },
  { name: 'rekentabel', title: 'rekentabel', icon: 'mathtable.png', dialog: () => (i) => rekentabelDialog(i) },
  { name: 'rooster', title: 'rooster', icon: 'layers.png', dialog: () => (i) => roosterDialog(i) },
  { name: 'tussenstap', title: 'tussenstap', icon: 'intermediate.png', dialog: () => (i) => tussenstapDialog(i) },
  { name: 'positietabel', title: 'positietabel', icon: 'positiontable.png', dialog: () => (i) => positietabelDialog(i) },
  { name: 'pijlenschema', title: 'pijlenschema', icon: 'arrowschema.png', dialog: () => (i) => pijlenschemaDialog(i) },
  { name: 'horner', title: 'tabel van Horner', icon: 'horner.png', dialog: () => (i) => hornerDialog(i) },
  { name: 'rekenreeks', title: 'Rekenreeks', icon: 'rekenreeks.png', dialog: () => (i) => rekenreeksDialog(i) },
  { name: 'visual-order', title: 'Visuele volgorde', icon: 'visual-order.png', dialog: () => (i) => visueleVolgordeDialog(i) },
  { name: 'tip', title: 'Tip', icon: 'tip.svg', dialog: (p) => (i) => tipDialog(i, p) },
  { name: 'heuristiek', title: 'Heuristiek', icon: 'heuristiek.png', dialog: (p) => (i) => heuristiekDialog(i, p) },
  { name: 'getalbeeld', title: 'Getalbeeld', icon: 'getalbeeld.png', dialog: () => (i) => getalbeeldDialog(i), needsRehydrate: true },
  { name: 'klok', title: 'Klok', icon: 'clock.png', dialog: () => (i) => klokDialog(i) },
  { name: 'mab', title: 'MAB', icon: 'mab.png', dialog: () => (i) => mabDialog(i), needsRehydrate: true },
];

export const ALL_CUSTOM_BUTTON_COMMANDS = BUTTONS.map((b) => b.name);

let registeredIconPath = '';
export function getCustomButtonIconPath(): string {
  return registeredIconPath;
}

export function registerCustomButtons(iconPath: string) {
  registeredIconPath = iconPath;
  for (const spec of BUTTONS) {
    FroalaEditor.DefineIcon(spec.name, { SRC: `${iconPath}${spec.icon}`, template: 'image' });
    FroalaEditor.RegisterCommand(spec.name, {
      title: spec.title,
      icon: spec.name,
      focus: false,
      undo: true,
      refreshAfterCallback: true,
      callback: function () {
        const editor = this;
        const editable: HTMLElement | undefined = editor?.$el?.[0];
        spec.dialog(iconPath)((html) => {
          if (!html) return;
          editor.html.insert(html, true);
          if (spec.needsRehydrate && editable) rehydrate(editable);
        });
      },
    });
  }
}
